import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  AbilitySubjectType,
  AutomationContext,
  AutomationTrigger,
  AutomationTriggerConfig,
  IAutomation,
  IAutomationAction,
  IAutomationRuleGroup,
} from '@kinet-open-network/shared/data-access/model';

export class Automation<T extends AutomationTrigger = AutomationTrigger>
  extends BaseModel<Automation, 'Automation'>
  implements IAutomation<T>
{
  static override readonly modelName: AbilitySubjectType = 'Automation';

  name!: string;
  description?: string | null;
  trigger!: T;
  context!: AutomationContext;
  conditions?: IAutomationRuleGroup;
  triggerData?: AutomationTriggerConfig<T>;
  actions?: IAutomationAction[];
  enabled!: boolean;

  canExecute(): boolean {
    return (
      this.enabled &&
      this.context !== 'message' &&
      [AutomationTrigger.Manual, AutomationTrigger.Cron].includes(this.trigger)
    );
  }
}
